import React from 'react';
import { FinanceFinancialDetails, FinancialDetails, OperatingLeaseFinancialDetails } from 'cpes-common';
import { TranslationFormat, useTranslationWithFormatting } from 'localization/useTranslationWithFormatting';
import { DataOverview, DefinitionListHorizontal, DefinitionListItem } from '@cp-shared-19/frontend-ui';

export const BaseSection: React.FC<{ details: FinancialDetails; isFinanceLeaseContract?: boolean }> = ({
    details,
    isFinanceLeaseContract,
}) => {
    const { t, f } = useTranslationWithFormatting('financial-details');

    const financeBaseSectionItemList: DefinitionListItem[] = [
        {
            label: t('baseSection.startDate'),
            value: f(details.startDate, TranslationFormat.DATE),
        },
        {
            label: t('baseSection.endDate'),
            value: f(details.endDate, TranslationFormat.DATE),
        },
        {
            label: t('baseSection.pendingCapital.label'),
            value: f((details as FinanceFinancialDetails).pendingCapital, TranslationFormat.CURRENCY),
            tooltip: t('baseSection.pendingCapital.tooltip'),
            labelId: t('baseSection.pendingCapital.label'),
        },
        {
            label: t('baseSection.amortizedCapital'),
            value: f((details as FinanceFinancialDetails).amortizedCapital, TranslationFormat.CURRENCY),
        },
        {
            label: t('baseSection.nominalAmount.label'),
            value: f((details as FinanceFinancialDetails).nominalAmount, TranslationFormat.CURRENCY),
        },
    ].filter(item => !!item.value);

    if (isFinanceLeaseContract) {
        financeBaseSectionItemList.push({
            label: t('baseSection.bailAmount.label'),
            value: f((details as OperatingLeaseFinancialDetails).bailAmount, TranslationFormat.CURRENCY), // ES-16 display  bailAmount
            tooltip: t('baseSection.bailAmount.tooltip'),
            labelId: t('baseSection.bailAmount.label'),
        });
    }

    return (
        <DataOverview titleLevel={5} title={t('baseSection.title')}>
            <DefinitionListHorizontal list={financeBaseSectionItemList} />
        </DataOverview>
    );
};
